<template>
  <div class="flex">
    <h3
      class="
        font-AlternateGotFont
        2xl:text-4xl
        text-3xl
        font-light
        text-STorange
        uppercase
      "
    >
      {{ text }}
    </h3>
    <img
      class="h-2 w-4 ml-2 my-auto relative top-1"
      :src="getImg()"
      alt="arrows"
    />
  </div>
</template>

<script>
import { generateFullPath } from "../../utils/fileHelpers";

export default {
  name: "Title",

  props: {
    text: String,
  },

  methods: {
    getImg() {
      return generateFullPath("/themes/klaycamp/img/arrows2.png");
    },
  },
};
</script>
